import React from 'react'
import { Form } from '@guillotinaweb/react-gmi'
import { ErrorZone } from '../../components/error_zone'
import { Select } from '@guillotinaweb/react-gmi'
import { useTraversal } from '@guillotinaweb/react-gmi'
import { useSetState } from 'react-use'
import { Input } from '@guillotinaweb/react-gmi'
import { stringToSlug } from '@guillotinaweb/react-gmi'
import { Button } from '@guillotinaweb/react-gmi'
import { useLocation } from '@guillotinaweb/react-gmi'

const initial = {
  '@type': 'Bodega',
  nombre: '',
  id: '',
  internal_id: '',
  id_pais: '',
}

export function BodegaForm({ onSubmit, actionName, title }) {
  const Ctx = useTraversal()
  const [error, setError] = React.useState(undefined)
  const [paises, setPaises] = React.useState([])
  const [state, setState] = useSetState(initial)
  const [loading, setLoading] = React.useState(false)
  const [, navigate] = useLocation()

  React.useEffect(() => {
    ;(async () => {
      let data = await Ctx.client.getPaises()
      setPaises(data)
    })()
  }, [])

  const submit = async () => {
    if (state.nombre === '' || state.id === '' || state['id_pais'] === '') {
      setError('Todos los campos son necesarios')
      return
    }

    setLoading(true)
    const res = await Ctx.client.post('/bodegas/', state)
    if (res.status === 201) {
      Ctx.flash('Bodega creada', 'success')
      Ctx.cancelAction()
      navigate({ path: `/bodegas/${state.id}/` }, true)
    } else {
      setLoading(false)
      const response = await res.json()
      setError('Server Error:' + response.msg || res.status)
    }
  }

  const rest = {
    onFocus: () => setError(undefined),
  }

  return (
    <Form onSubmit={submit}>
      <h1 className="title is-size-4 has-text-primary">Añadir Bodega</h1>
      {error && <ErrorZone className="is-size-7">{error}</ErrorZone>}

      <Input
        className="is-size-6"
        onChange={(ev) => {
          let slug = stringToSlug(ev)
          let internal_id = slug.replace('-', '').substring(0, 4)
          setState({ nombre: ev, id: slug, internal_id })
        }}
        id="Nombre"
        placeholder="Nombre"
        value={state.nombre}
        {...rest}
      />

      <Input
        className="is-size-6"
        onChange={(ev) => setState({ id: ev })}
        id="Url"
        placeholder="Url Amigable"
        value={state.id}
        {...rest}
      />

      <Input
        className="is-size-6"
        onChange={(ev) => setState({ internal_id: ev })}
        id="id_bodega"
        minLength={4}
        maxLength={4}
        placeholder="id_bodega"
        value={state.internal_id}
        {...rest}
      />

      <div className="field">
        <label className="label">Pais</label>
        <Select
          value={state.id_pais}
          options={paises}
          appendDefault
          onChange={(ev) => setState({ id_pais: ev.target.value })}
          classWrap={'is-small'}
        />
      </div>

      <p>&nbsp;</p>
      <div className="level level-right">
        <Button className="is-primary" loading={loading}>
          Añadir
        </Button>
      </div>
    </Form>
  )
}

/**
'{"@type": "Bodega", "nombre": "Prova jordi", "@id": "prova-jordi",
  "internal_id": "prvj", "id_pais": "es"}
 */
